<template>
  <v-dialog
    v-if="value"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="$emit('closed', true)"
    @keydown.esc="$emit('closed', true)"
    persistent
    max-width="545px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">mdi-package-variant-closed</v-icon>
          {{ lang.catalog.stock.dialog.title }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="$emit('closed', true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-2">
        <v-container class="px-0 stock-form">
          <v-form
            ref="StockForm"
            v-model="valid"
            lazy-validation
            :disabled="get_interface.loading"
          >
            <v-row>
              <v-col cols="4" class="py-0 px-1">
                <v-text-field
                  v-model="form.qty"
                  :label="lang.catalog.stock.dialog.qty"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  type="number"
                  autocomplete="new-password"
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="py-0 px-1">
                <div class="checkbox-select">
                  <v-checkbox
                    v-model="unit"
                    class="checkbox__"
                    light
                    hide-details
                  ></v-checkbox>
                  <v-currency-field
                    v-model="form.unit"
                    :label="lang.catalog.stock.dialog.unit"
                    :loading="get_interface.loading"
                    :disabled="get_interface.loading || !unit"
                    class="field__"
                    filled
                    hide-details
                  />
                </div>
              </v-col>
              <v-col cols="4" class="py-0 px-1">
                <v-currency-field
                  v-model="form.total"
                  :label="lang.catalog.stock.dialog.total"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading || unit"
                  class="field__"
                  filled
                  hide-details
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="stock_(value, 0)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
          text
        >
          {{ lang.catalog.stock.dialog.reject }}
        </v-btn>
        <v-btn
          @click="stock_(value, 1, form)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
          color="green darken-1"
          text
        >
          {{ lang.catalog.stock.dialog.accept }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import catalog from '../../mixins/index'

export default {
  mixins: [ appdata, utils, catalog ],
  props: {
    value: {
      type: Object,
      required: true
    },
    dialog: {
      type: Boolean,
      default: true
    },
    qty: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    valid: false,
    form: {
      qty: 0,
      unit: 0,
      total: 0
    },
    unit: false
  }),
  watch: {
    unit (newVal) {
      if (newVal) this.form.total = parseFloat(this.form.qty * parseFloat(this.form.unit))
    },
    'form.qty' (qty) {
      if (this.unit) this.form.total = parseFloat(qty * parseFloat(this.form.unit))
    },
    'form.unit' () {
      if (this.unit) {
        let { qty, unit } = this.form
        this.form.total = parseFloat(qty * parseFloat(unit))
      }
    },
    'form.total' () {
      if (!this.unit) {
        let { qty, total } = this.form
        this.form.unit = parseFloat(parseFloat(total) / qty)
      }
    }
  },
  created () {
    this.form.qty = this.qty
  }
}
</script>

<style lang="scss">
.stock-form {
  #app & {
    .checkbox-select {
      display: inline-block;
      border-radius: 5px;
      background: rgba(0,0,0,0.04);
      .v-input {
        margin: 0px;
        display: inline-block;
        &.checkbox__ {
          max-width: 15% !important;
          padding: 0px !important;
          .v-input--selection-controls__input {
            margin-left: 3px;
            .v-icon {
              top: -6.5px;
            }
            .v-input--selection-controls__ripple {
              margin-top: 0px !important;
              &:before {
                background: transparent !important;
              }
            }
          }
        }
        &.field__ {
          max-width: 85% !important;
        }
      }
    }
  }
}
</style>
